import React, { useState } from 'react';
import * as styles from './MembershipTopic.module.scss';
import TopicBreadcrumbs from './TopicBreadcrumbs';
import TopicNameWithIcon from './TopicNameWithIcon';
import type { TopicWithMembershipTopics } from './useMembershipTopics';
import Button from '../components/Button';
import Caret from '../components/Caret';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';
import Link from '../utils/router/Link';
import topicPath from '../utils/url/topicPath';

const MEMBERSHIP_TOPIC_TOPIC_FRAGMENT = gql(`
  fragment MembershipTopic_topic on Topic {
    id
    ...topicPath_topic
    ancestors {
      ...TopicBreadcrumbs_topics
    }
    ...TopicNameWithIcon_topic
  }
`);

interface MembershipTopicProps {
  topic: TopicWithMembershipTopics<
    DocumentType<typeof MEMBERSHIP_TOPIC_TOPIC_FRAGMENT>
  >;
  showBreadcrumbs?: boolean;
}

const MembershipTopic = ({ topic, showBreadcrumbs }: MembershipTopicProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const path = topicPath(topic);

  return (
    <>
      <div className={styles.header}>
        <Link className={styles.info} to={path}>
          {showBreadcrumbs && (topic.ancestors?.length ?? 0) > 0 && (
            <TopicBreadcrumbs topics={topic.ancestors} size="small" />
          )}
          <TopicNameWithIcon topic={topic} />
        </Link>
        {topic.membershipChildTopics.length > 0 && (
          <Button
            className={styles.expandButton}
            onClick={() => setIsExpanded(!isExpanded)}
          >
            <Caret direction={isExpanded ? 'up' : 'down'} size="small" />
          </Button>
        )}
      </div>
      {topic.membershipChildTopics.length > 0 && isExpanded && (
        <ul className={styles.subtopics}>
          {topic.membershipChildTopics.map((membershipChildTopic) => (
            <li key={membershipChildTopic.id}>
              <MembershipTopic topic={membershipChildTopic} />
            </li>
          ))}
        </ul>
      )}
    </>
  );
};

export default MembershipTopic;
